import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, ShoppingCart, Clock, Coffee } from 'lucide-react';
const items = [{
  icon: BookOpen,
  title: 'Guía Principal',
  description: 'El Protocolo de 24 Horas para ver resultados inmediatos en tus anillos y ropa.'
}, {
  icon: Calendar,
  title: 'Plan de 7 Días',
  description: 'La hoja de ruta paso a paso para recuperar tu energía sin pasar hambre.'
}, {
  icon: ShoppingCart,
  title: 'Lista de Compras "Oro"',
  description: 'Los ingredientes exactos que desinflaman tu cuerpo (y cuáles evitar).'
}, {
  icon: Clock,
  title: 'Manual de Micro-Hábitos',
  description: 'Acciones de 10 minutos que estabilizan tu azúcar después de comer.'
}, {
  icon: Coffee,
  title: 'Guía de Infusiones Curativas',
  description: 'El secreto natural para dormir profundo y despertar ligera.'
}];
export function WhatYouGet() {
  return <section className="py-20 px-6 bg-white" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-124">
          Lo que recibes hoy
        </motion.h2>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-125">
          {items.map((item, index) => {
          const Icon = item.icon;
          // Make the last item span full width on tablet, or fit nicely in grid
          const isLastOdd = index === items.length - 1 && items.length % 2 !== 0;
          return <motion.div key={index} className={`bg-brand-cream p-8 rounded-2xl border border-brand-gold/20 hover:border-brand-gold/50 transition-colors ${isLastOdd ? 'md:col-span-2 lg:col-span-1' : ''}`} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-126">
                <div className="w-14 h-14 bg-brand-green/10 rounded-full flex items-center justify-center mb-6" data-id="element-127">
                  <Icon className="w-7 h-7 text-brand-green" data-id="element-128" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-brand-green" data-id="element-129">
                  {item.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-130">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}